import { connect } from 'react-redux';
import { compose } from 'redux';
import { withConfig } from 'modules/shell/hoc/withConfig';
import { withLogger } from 'modules/shell/hoc/withLogger';
import { withStyles } from '@material-ui/core/styles';
import { setUser, addNotification } from './actions';
import App from './App';
import styles from './App.styles';

const mapStateToProps = ({ user: { data }, userGroups: { activeADGroup }, clientingModule }) => ({
  isUserLogged: data.logged,
  userId: data.employeeNumber,
  userBrand: data.brand,
  isSuperUser: data.isSuperUser,
  activeADGroup,
  userADGroups: data.groups,
  isMinimized: clientingModule.voice.isMinimized,
  userStore: data.storeNumber,
});

const mapDispatchToProps = {
  setUser,
  addNotification,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles),
  withConfig(),
  withLogger(),
)(App);
